<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人赛赛务管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 个人赛程 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">个人赛赛程</span>
        </el-col>
      </el-row>
      <raceSchedule :list="raceScheduleList" @showNational="navDialog = true"></raceSchedule>
    </el-card>
    <!-- 个人赛赛务工具 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">个人赛赛务工具</span>
        </el-col>
      </el-row>
      <el-row :gutter="30" style="margin-top: 34px">
        <el-col :span="4" v-for="(item, i) of racingToolList" v-bind:key="i">
          <tool :item="item" :index="i" @showPop="onShowGoodnewsPoster"></tool>
        </el-col>
      </el-row>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="12">
        <!-- 待处理事务 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">待处理事务</span>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col
              :span="6"
              style="padding: 0 10px"
              v-for="(item, i) of processedList"
              v-bind:key="i"
            >
              <todo :item="item" :index="i"></todo>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12">
        <!-- 数据统计 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">数据统计</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="6"
              v-for="(item, i) of dataStatisticsList"
              v-bind:key="i"
            >
              <div class="processed-list-back">
                <div class="dataStatistics-desc">{{ item.number }}</div>
                <div class="dataStatistics-title">{{ item.title }}</div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- 数据统计 -->
    <el-tabs type="border-card" style="margin-top: 15px" v-if="false">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="rank-class">
            考量排行榜 <span class="rank-update">每天更新</span>
          </div>
          <!-- <el-divider></el-divider> -->
          <div class="rankTypeback">
            <div class="rank-type">
              <div
                :class="
                  marketingRankType === 'marketing'
                    ? 'rankTypeActive rankTypeActive1'
                    : 'rankTypeItem'
                "
                @click="ranktypeClicked('consideration', 'marketing')"
              >
                直营
              </div>
              <div
                :class="
                  marketingRankType === 'authorization'
                    ? 'rankTypeActive rankTypeActive1'
                    : 'rankTypeItem'
                "
                @click="ranktypeClicked('consideration', 'authorization')"
              >
                授权
              </div>
            </div>
            <el-table
              :data="marketingRankList"
              style="width: 100%"
              size="small"
            >
              <el-table-column prop="rankStr" label="排名" width="50">
              </el-table-column>
              <el-table-column prop="districtName" label="赛区" width="100">
              </el-table-column>
              <el-table-column label="考量" prop="consider">
                <template scope="scope">
                  <el-progress
                    type="line"
                    :percentage="(scope.row.consider / 10000) * 100"
                    :format="format(scope.row, scope.column)"
                    color="#2db8f8"
                    :text-inside="false"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="rank-class">
            缴费排行榜 <span class="rank-update">每天更新</span>
          </div>
          <!-- <el-divider></el-divider> -->
          <div class="rankTypeback">
            <div class="rank-type">
              <div
                :class="
                  payRankType === 'marketing'
                    ? 'rankTypeActive rankTypeActive2'
                    : 'rankTypeItem'
                "
                @click="ranktypeClicked('pay', 'marketing')"
              >
                直营
              </div>
              <div
                :class="
                  payRankType === 'authorization'
                    ? 'rankTypeActive rankTypeActive2'
                    : 'rankTypeItem'
                "
                @click="ranktypeClicked('pay', 'authorization')"
              >
                授权
              </div>
            </div>
            <el-table :data="payRankRankList" style="width: 100%" size="small">
              <el-table-column prop="rankStr" label="排名" width="50">
              </el-table-column>
              <el-table-column prop="districtName" label="赛区" width="100">
              </el-table-column>
              <el-table-column label="金额" prop="consider">
                <template scope="scope">
                  <el-progress
                    type="line"
                    :percentage="(scope.row.consider / 10000) * 100"
                    :format="format(scope.row, scope.column)"
                    color="#FFA94C"
                    :text-inside="false"
                  >
                  </el-progress>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="rank-class">
            转化率排行榜 <span class="rank-update">每天更新</span>
          </div>
          <!-- <el-divider></el-divider> -->
          <div class="rankTypeback">
            <div class="rank-type">
              <div
                :class="
                  conversionRankType === 'marketing'
                    ? 'rankTypeActive rankTypeActive3'
                    : 'rankTypeItem'
                "
                @click="ranktypeClicked('conversion', 'marketing')"
              >
                直营
              </div>
              <div
                :class="
                  conversionRankType === 'authorization'
                    ? 'rankTypeActive rankTypeActive3'
                    : 'rankTypeItem'
                "
                @click="ranktypeClicked('conversion', 'authorization')"
              >
                授权
              </div>
            </div>
            <el-table
              :data="conversionRankList"
              style="width: 100%"
              size="small"
            >
              <el-table-column prop="rankStr" label="排名" width="50">
              </el-table-column>
              <el-table-column prop="districtName" label="赛区" width="100">
              </el-table-column>
              <el-table-column label="初区域决选转化率" prop="consider">
                <template scope="scope">
                  <el-progress
                    thickness="10"
                    :percentage="scope.row.consider * 100"
                    :format="format(scope.row, scope.column)"
                    color="#4BCED0"
                    :text-inside="false"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
      <!-- <el-tab-pane label="城市初选">用户管理</el-tab-pane>
      <el-tab-pane label="区域决选">配置管理</el-tab-pane>
      <el-tab-pane label="城市赛">角色管理</el-tab-pane>
      <el-tab-pane label="国赛有组别">定时任务补偿</el-tab-pane>
      <el-tab-pane label="国赛无组别">定时任务补偿</el-tab-pane> -->
    </el-tabs>
    <individual-goodnews-poster ref="goodnewsPoster" />
    <!-- 导航 -->
    <el-dialog
      :visible.sync="navDialog"
      width="560px"
      @close="navDialog = false"
    >
      <div class="nav-menu-row">
        <el-row>
          <el-col :span="12" v-for="item of navMenu" :key="item.id">
            <div @click="handleToPage(item)" class="nav-menu-col" :class="'card-background' + item.id">
                <i class="icon iconfont" :class="item.icon"></i>
                <div>
                  <span>{{ item.title }}</span>
                  <div class="desc">{{ item.desc }}</div>
                </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dataStatistics, pendingMatter } from '@/http/api'
import IndividualGoodnewsPoster from './individual_goodnews_poster.vue'

export default {
  components: {
    IndividualGoodnewsPoster
  },
  data () {
    return {
      navDialog: false,
      navMenu: [
        { id: 1, title: '报名资格管理', desc: '晋级状态、报名缴费信息', icon: 'icon-tuandui', path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/nationalgroup_raceManagement' },
        { id: 2, title: '报到', desc: '签到、物料领取', icon: 'icon-cuoqingdengji', path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/check_in' },
        { id: 3, title: '小组赛抽签', desc: '抽取小组赛比赛号码牌', icon: 'icon-shuzi', path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/gd?g=1' },
        { id: 4, title: '无组别比赛抽签', desc: '抽取无组别比赛号码牌', icon: 'icon-shuzi', path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/gd?g=2' }
      ],
      marketingRankType: 'marketing',
      payRankType: 'marketing',
      conversionRankType: 'marketing',
      payRankRankList: [
        {
          rankStr: 1,
          districtName: '天津赛区',
          consider: '9999'
        },
        {
          rankStr: 2,
          districtName: '天津赛区',
          consider: '9000'
        },
        {
          rankStr: 3,
          districtName: '天津赛区',
          consider: '8000'
        },
        {
          rankStr: 4,
          districtName: '天津赛区',
          consider: '7000'
        },
        {
          rankStr: 5,
          districtName: '天津赛区',
          consider: '6000'
        },
        {
          rankStr: 6,
          districtName: '天津赛区',
          consider: '5500'
        },
        {
          rankStr: 7,
          districtName: '天津赛区',
          consider: '4000'
        },
        {
          rankStr: 8,
          districtName: '天津赛区',
          consider: '2000'
        }
      ],
      marketingRankList: [
        {
          rankStr: 1,
          districtName: '天津赛区',
          consider: '10000'
        },
        {
          rankStr: 2,
          districtName: '天津赛区',
          consider: '9000'
        },
        {
          rankStr: 3,
          districtName: '天津赛区',
          consider: '8000'
        },
        {
          rankStr: 4,
          districtName: '天津赛区',
          consider: '7000'
        },
        {
          rankStr: 5,
          districtName: '天津赛区',
          consider: '6000'
        },
        {
          rankStr: 6,
          districtName: '天津赛区',
          consider: '5500'
        },
        {
          rankStr: 7,
          districtName: '天津赛区',
          consider: '4000'
        },
        {
          rankStr: 8,
          districtName: '天津赛区',
          consider: '2000'
        }
      ],
      conversionRankList: [
        {
          rankStr: 1,
          districtName: '天津赛区',
          consider: 0.92
        },
        {
          rankStr: 2,
          districtName: '天津赛区',
          consider: 0.78
        },
        {
          rankStr: 3,
          districtName: '天津赛区',
          consider: 0.65
        },
        {
          rankStr: 4,
          districtName: '天津赛区',
          consider: 0.56
        },
        {
          rankStr: 5,
          districtName: '天津赛区',
          consider: 0.41
        },
        {
          rankStr: 6,
          districtName: '天津赛区',
          consider: 0.33
        },
        {
          rankStr: 7,
          districtName: '天津赛区',
          consider: 0.24
        },
        {
          rankStr: 8,
          districtName: '天津赛区',
          consider: 0.17
        }
      ],
      raceScheduleList: [
        {
          scheduleName: '城市初选',
          authorityFlag: this.$chnEngStatusCode.MATCH_INDIVIDUAL_PRELIMINARY
        }, {
          scheduleName: '区域决选',
          authorityFlag: this.$chnEngStatusCode.MATCH_INDIVIDUAL_FINAL
        }, {
        //   scheduleName: '区域决选',
        //   authorityFlag: this.$chnEngStatusCode.MATCH_CITY_REGIONAL_COMPETITION
        // }, {
          scheduleName: '全国总决选',
          authorityFlag: this.$chnEngStatusCode.MATCH_NATIONAL_FINALS
        }
      ],
      scheduleCardList: [
        {
          scheduleName: '初选',
          scheduleId: '1',
          promotionNum: 0,
          signUpNum: 0,
          percent: 0,
          flag: this.$chnEngStatusCode.INDIVIDUAL_PRELIMINARY
        }, {
          scheduleName: '复选',
          scheduleId: '2',
          promotionNum: 0,
          signUpNum: 0,
          percent: 0,
          flag: this.$chnEngStatusCode.INDIVIDUAL_FINAL
        }, {
          scheduleName: '城市总决选',
          scheduleId: '3',
          promotionNum: 0,
          signUpNum: 0,
          percent: 0,
          flag: this.$chnEngStatusCode.CITY_REGIONAL_COMPETITION
        }, {
          scheduleName: '国赛有组别',
          scheduleId: '4',
          promotionNum: 0,
          signUpNum: 0,
          percent: 0,
          flag: this.$chnEngStatusCode.NATIONAL_FINALS
        }, {
          scheduleName: '国赛无组别',
          scheduleId: '4',
          promotionNum: 0,
          signUpNum: 0,
          percent: 0,
          flag: this.$chnEngStatusCode.NATIONAL_FINALS
        }
      ],
      racingToolList: [
        {
          rightTitle: '试卷管理',
          rightDesc: '可查看各赛区考量统计',
          icon: 'icon-tisheng',
          menuTag: 5,
          path: '/dataStatistics',
          authorityFlag: this.$chnEngStatusCode.data_statistics
        },
        {
          rightTitle: '比赛时间管理',
          rightDesc: '管理赛区/学校比赛时间',
          icon: 'icon-rili',
          menuTag: 1,
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_gametime_manage',
          authorityFlag: this.$chnEngStatusCode.individual_gametime_manage
        },
        {
          rightTitle: '区域决选考场管理',
          rightDesc: '新增、修改考场场地/会议号',
          icon: 'icon-house-full',
          menuTag: 2,
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_room_list',
          authorityFlag: this.$chnEngStatusCode.examination_room_list
        },
        {
          rightTitle: '国赛考场管理',
          rightDesc: '新增、修改考场场地/时间',
          icon: 'icon-xuexiao_xuexiaoxinxi',
          menuTag: 4,
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_national_room_list',
          authorityFlag: this.$chnEngStatusCode.national_finals_examination_room_list
        },
        {
          rightTitle: '喜报制作',
          rightDesc: '可生成晋级海报',
          icon: 'icon-haibaosheji',
          menuTag: 3,
          showPop: true,
          authorityFlag: this.$chnEngStatusCode.xibaozhizuo
        }
      ],
      dataStatisticsList: [
        {
          title: '城市初选缴费报名',
          key: 'payForThePreliminaryCompetition',
          number: 0
        }, {
          title: '城市初选参赛人数',
          key: 'thePreliminaryCompetitionNum',
          number: 0
        }, {
          title: '城市初选晋级人数',
          key: 'thePreliminaryCompetitionPromotionNum',
          number: 0
        }, {
          title: '发放证书人数',
          key: 'numberOfIssuingCertificates',
          number: 0
        }, {
          title: '区域决选缴费报名',
          key: 'payForTheRematch',
          number: 0
        }, {
          title: '区域决选参赛人数',
          key: 'numberOfParticipantsInTheRematch',
          number: 0
        }, {
          title: '区域决选晋级人数',
          key: 'theRematchCompetitionNum',
          number: 0
        }, {
          title: '初转复转化率',
          key: 'initialConversionRate',
          number: '0%'
        }
      ],
      processedList: [
        {
          // iconImg: require('@/assets/img/icon-school.png'),
          icon: 'icon-xuexiao',
          title: '待审核学校',
          key: 'schoolToBeAudited',
          path: '/b_data_Management/b_school_management',
          authorityFlag: this.$chnEngStatusCode.b_school_management_1,
          menuTag: 1,
          number: '0'
        },
        {
          // iconImg: require('@/assets/img/icon-shijuanguanli.png'),
          icon: 'icon-shijuan',
          title: '待审核试卷',
          key: 'examinationPaperToBeAudited',
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_considerations',
          status: '0',
          authorityFlag: this.$chnEngStatusCode.individual_school_considerations,
          menuTag: 2,
          number: '0'
        },
        {
          // iconImg: require('@/assets/img/icon-waitsend.png'),
          icon: 'icon-fapiaoyoujidizhi',
          title: '待寄出试卷',
          key: 'testPaperToBeSentOut',
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_considerations',
          status: '1',
          authorityFlag: this.$chnEngStatusCode.individual_school_considerations_1,
          menuTag: 3,
          number: '0'
        },
        {
          // iconImg: require('@/assets/img/icon-waitReceive.png'),
          icon: 'icon-ai49',
          title: '待收回试卷',
          key: 'examinationPaperToBeRecalled',
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_considerations',
          status: '3',
          authorityFlag: this.$chnEngStatusCode.individual_school_considerations_3,
          menuTag: 4,
          number: '0'
        },
        // {
        //   // iconImg: require('@/assets/img/icon-waitSite.png'),
        //   icon: 'icon-xuexiao_xuexiaoxinxi',
        //   title: '待审核场地',
        //   key: 'siteToBeAudited',
        //   authorityFlag: this.$chnEngStatusCode,
        //   menuTag: 5,
        //   number: '0'
        // },
        {
          // iconImg: require('@/assets/img/icon-waitDeliver.png'),
          icon: 'icon-daifahuo',
          title: '待支付订单',
          key: 'prepaidOrder',
          path: '/product_Management/product_management',
          status: '1',
          authorityFlag: this.$chnEngStatusCode.product_management_1,
          menuTag: 6,
          number: '0'
        },
        {
          // iconImg: require('@/assets/img/icon-sendDeliver.png'),
          icon: 'icon-fahuo2',
          title: '待发货订单',
          key: 'orderForDelivery',
          path: '/product_Management/product_management',
          status: '2',
          authorityFlag: this.$chnEngStatusCode.product_management_2,
          menuTag: 7,
          number: '0'
        },
        {
          // iconImg: require('@/assets/img/icon-refund.png'),
          icon: 'icon-tuikuanguanli',
          title: '待处理退款申请',
          key: 'pendingRefund',
          path: '/product_Management/product_management',
          status: '5',
          authorityFlag: this.$chnEngStatusCode.product_management_5,
          menuTag: 8,
          number: '0'
        }
      ]
    }
  },
  created () {
    this.getDatas()
    this.getRaceSchedules()
  },
  methods: {
    getRaceSchedules () {
      this.$http.get('/homePage/scheduleStatisticsBySeason', { params: { activityType: this.$chnEngStatusCode.activityType, season: this.$chnEngStatusCode.defaultSeason } }).then(res => {
        if (res.code === 200) {
          res.data.forEach((item, i) => {
            item.authorityFlag = `MATCH_${item.scheduleFlag}`
            if (i === 0) { // 初选
              item.path = '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/preliminary_raceManagement'
            } else if (i === 1) { // 复选
              item.path = '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/rematch_raceManagement'
            // } else if (i === 2) { // 区域
            //   item.path = ''
            } else if (i === 2) { // 总决选
              item.showPop = true
            }
          })
          this.raceScheduleList = res.data
        }
      })
    },
    // getRaceScheduleList () {
    //   this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(data => {
    //     const params = { activityType: this.$chnEngStatusCode.activityType }
    //     individualScheduleStatistics(params).then(res => {
    //       if (res.code === 200) {
    //         // 城市初选
    //         data[0].signUpNum = res.data.theNumberOfParticipantsInThePreliminaryRound
    //         data[0].promotionNum = res.data.theNumberOfParticipantsInThePreliminaryRoundPromotion
    //         // 区域决选
    //         data[1].signUpNum = res.data.numberOfParticipantsInTheRematch
    //         data[1].promotionNum = res.data.numberOfParticipantsInTheRematchPromotion
    //         // 城市总
    //         data[2].signUpNum = res.data.totalCityRunoff
    //         data[2].promotionNum = res.data.totalCityRunoffPromotion
    //         // 总决赛 有组别
    //         data[3].signUpNum = res.data.thereAreDivisionsInTheNationalCompetition
    //         data[3].promotionNum = res.data.thereAreDivisionsInTheNationalCompetitionPromotion
    //         // 总决赛 无组别
    //         // this.scheduleCardList[4].signUpNum = res.data.thereAreNoDivisionsInTheNationalCompetition
    //         // this.scheduleCardList[4].promotionNum = res.data.thereAreNoDivisionsInTheNationalCompetitionPromotion
    //         this.raceScheduleList = data
    //         console.log(this.raceScheduleList)
    //       }
    //     })
    //   })
    // },
    getDatas () {
      const params = { activityType: this.$chnEngStatusCode.activityType }
      // 赛程统计人数
      // individualScheduleStatistics(params).then(res => {
      //   if (res.code === 200) {
      //     this.scheduleCardList[0].signUpNum = res.data.theNumberOfParticipantsInThePreliminaryRound
      //     this.scheduleCardList[0].promotionNum = res.data.theNumberOfParticipantsInThePreliminaryRoundPromotion
      //     this.scheduleCardList[1].signUpNum = res.data.numberOfParticipantsInTheRematch
      //     this.scheduleCardList[1].promotionNum = res.data.numberOfParticipantsInTheRematchPromotion
      //     this.scheduleCardList[2].signUpNum = res.data.totalCityRunoff
      //     this.scheduleCardList[2].promotionNum = res.data.totalCityRunoffPromotion
      //     this.scheduleCardList[3].signUpNum = res.data.thereAreDivisionsInTheNationalCompetition
      //     this.scheduleCardList[3].promotionNum = res.data.thereAreDivisionsInTheNationalCompetitionPromotion
      //     this.scheduleCardList[4].signUpNum = res.data.thereAreNoDivisionsInTheNationalCompetition
      //     this.scheduleCardList[4].promotionNum = res.data.thereAreNoDivisionsInTheNationalCompetitionPromotion

      //     this.scheduleCardList.forEach(item => {
      //       item.percent = item.signUpNum ? (item.promotionNum / item.signUpNum) * 100 : 0
      //     })
      //   }
      // })
      // 数据统计
      dataStatistics(params).then(res => {
        if (res.code === 200) {
          Object.keys(res.data).forEach(key => {
            this.dataStatisticsList.find(item => item.key === key).number = key === 'initialConversionRate' ? `${res.data[key]}%` : res.data[key]
          })
        }
      })
      // 待处理事务
      pendingMatter(params).then(res => {
        if (res.code === 200) {
          Object.keys(res.data).forEach(key => {
            if (this.processedList.find(item => item.key === key)) {
              this.processedList.find(item => item.key === key).number = res.data[key]
            }
          })
        }
      })
    },
    format (row, column) {
      // console.log('column', row)
      return () => {
        if (column.label === '考量') {
          return row.consider
        } else if (column.label === '金额') {
          return '￥' + row.consider
        } else if (column.label === '初区域决选转化率') {
          return (row.consider * 100).toFixed(2) + '%'
        }
      }
    },
    // // 赛程点击事件
    // scheduleCardTap (scheduleData) {
    //   console.log('e', scheduleData)
    //   let turnUrl = ''
    //   switch (scheduleData.id) {
    //     case '1': // 初选
    //       turnUrl = '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/preliminary_raceManagement'
    //       break
    //     case '2':
    //       turnUrl = '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/rematch_raceManagement'
    //       break
    //     case '4':
    //       // 弹窗
    //       this.navDialog = true
    //       // turnUrl = '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/nationalgroup_raceManagement'
    //       break
    //     default:
    //       turnUrl = ''
    //       break
    //   }
    //   if (turnUrl) {
    //     this.$router.push(
    //       {
    //         path: turnUrl,
    //         query: {
    //           scheduleFlag: scheduleData.scheduleFlag
    //         }
    //       }
    //     )
    //   }
    // },
    // 赛务工具点击回调
    racingToolClicked (tag) {
      switch (tag) {
        case '1':
          // this.$router.push('/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_school_considerations')
          this.$router.push('/raceManagement/individual_management/coupon')
          break
        case '2':
          this.$router.push('/product_Management/productcode_management')
          break
        case '3':
          this.$router.push('/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/individual_gametime_manage')
          break
        case '4':
          this.$router.push('/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_room_list')
          break
        // case '5':
        //   this.$router.push('/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_room_list')
        //   break
        case '6':
          if (this.$refs.goodnewsPoster) {
            this.$refs.goodnewsPoster.open()
          }
          break
        case '7':
          this.$router.push('/raceManagement/individual_management/semi_final_form_code')
          break
        default:
          break
      }
    },
    onShowGoodnewsPoster () {
      if (this.$refs.goodnewsPoster) {
        this.$refs.goodnewsPoster.open()
      }
    },
    // 考量排行榜切换
    ranktypeClicked (rankType, item) {
      switch (rankType) {
        case 'consideration':
          this.marketingRankType = item
          break
        case 'pay':
          this.payRankType = item
          break
        case 'conversion':
          this.conversionRankType = item
          break
        default:
          break
      }
    },
    handleToPage ({ path, status }) {
      if (path) {
        const query = status ? { status } : null
        this.$router.push({ path, query })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.nav-menu-row{
}
.nav-menu-col{
  color: #fff;
  font-size: 16px;
  margin: 10px;
  border-radius: 4px;
  padding: 14px 20px 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  .desc{
    font-size: 12px;
    margin-top: 4px;
  }
  .icon{
    font-size: 36px;
    margin-right: 8px;
  }
}
::v-deep .el-progress__text {
  font-size: 10px !important;
}
.rankTypeback {
  margin: 10px 0px;
  padding: 20px;
  // border: 1px solid rgb(219, 219, 219);
}
.rankTypeItem {
  width: 42px;
  height: 24px;
  // border-radius: 6px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #aaa7a7;
  color: #fff;
  background-color: #aaa7a7;
  // margin-right: 10px;
  cursor: pointer;
}
.rankTypeActive {
  width: 42px;
  height: 24px;
  font-size: 12px;
  // border-radius: 6px;
  line-height: 24px;
  text-align: center;
  // margin-right: 10px;
  cursor: pointer;
  color: white;
}
.rankTypeActive1 {
  background-color: #2db8f8;
  border: 1px solid #2db8f8;
}
.rankTypeActive2 {
  background-color: #f8ae19;
  border: 1px solid #f8ae19;
}
.rankTypeActive3 {
  background-color: #4bced0;
  border: 1px solid #4bced0;
}
.rank-type {
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.rank-update {
  font-size: 12px;
  color: rgb(107, 107, 107);
}
.rank-class {
  font-size: 16px;
  color: rgb(39, 39, 39);
  margin-top: 5px;
}
.schedule_card {
  width: 100%;
  height: 54px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}

.schedule_gameName {
  text-align: left;
  color: white;
  font-size: 20px;
  margin-bottom: 6px;
}

.schedule_gameNumber {
  text-align: left;
  color: white;
  font-size: 12px;
}
</style>
